import React from 'react';
import FileUploader from '../../util/files/FileUploader';
const CommonFileBody = _ref => {
  let {
    onSelectFile,
    setUppyInstance,
    onUserEditFileStart,
    onUserEditFileEnd,
    iseSelectingMoreFilesDisabled
  } = _ref;
  return /*#__PURE__*/React.createElement(FileUploader, {
    onSelectFile: onSelectFile,
    setUppyInstance: setUppyInstance,
    onUserEditFileStart: onUserEditFileStart,
    onUserEditFileEnd: onUserEditFileEnd,
    isAddingFilesDisabled: iseSelectingMoreFilesDisabled
  });
};
export default CommonFileBody;